export interface Meeting {
  fullDate: Date;
  day: number | null;
  dayOfWeek: string;
  month: string;
  meetingHour: number | null;
  active: boolean;
  currentMonth: boolean;
  note?: string;
}

export const Meetings: Meeting[] = [
  {
    fullDate: new Date(2025, 2, 27),
    day: 27,
    dayOfWeek: 'QUI',
    month: 'MARÇO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 3, 8),
    day: 8,
    dayOfWeek: 'TER',
    month: 'ABRIL',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 4, 7),
    day: 7,
    dayOfWeek: 'QUA',
    month: 'MAIO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 5, 5),
    day: 5,
    dayOfWeek: 'QUI',
    month: 'JUNHO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 6, 2),
    day: 2,
    dayOfWeek: 'QUA',
    month: 'JULHO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 7, 7),
    day: 7,
    dayOfWeek: 'QUI',
    month: 'AGOSTO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 8, 4),
    day: 4,
    dayOfWeek: 'QUI',
    month: 'SETEMBRO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 9, 2),
    day: 2,
    dayOfWeek: 'QUI',
    month: 'OUTUBRO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 10, 6),
    day: 6,
    dayOfWeek: 'QUI',
    month: 'NOVEMBRO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
  {
    fullDate: new Date(2025, 11, 4),
    day: 4,
    dayOfWeek: 'QUI',
    month: 'DEZEMBRO',
    meetingHour: 9,
    active: true,
    currentMonth: false,
  },
];
